export const fieldNames = {
  fullName: 'fullName',
  email: 'email',
  mobileNumber: 'mobileNumber',
  companyName: 'companyName',
  billingPersonName: 'billingPersonName',
  billingAddress1: 'billingAddress1',
  billingAddress2: 'billingAddress2',
  billingPostalCode: 'billingPostalCode',
  billingCountry: 'billingCountry',
  billingCity: 'billingCity',
  billingState: 'billingState',
  billingDistrict: 'billingDistrict',
  shippingAddress1: 'shippingAddress1',
  shippingAddress2: 'shippingAddress2',
  shippingPostalCode: 'shippingPostalCode',
  shippingCountry: 'shippingCountry',
  shippingCity: 'shippingCity',
  shippingState: 'shippingState',
  haveOwnBankAccount: 'haveOwnBankAccount',
  accountHolder: 'accountHolder',
  nameAsPerBank: 'nameAsPerBank',
  accountType: 'accountType',
  accountNumber: 'accountNumber',
  confirmAccountNumber: 'confirmAccountNumber',
  bankName: 'bankName',
  branchName: 'branchName',
  ifscCode: 'ifscCode',
  doorNumber: 'doorNumber',
  locality: 'locality',
  villageOrTown: 'villageOrTown',
  mandal: 'mandal',
  currentState: 'currentState',
  currentDistrict: 'currentDistrict',
  currentPinCode: 'currentPinCode',
  currentCountry: 'currentCountry',
  acknowledgeBankDetails: 'acknowledgeBankDetails',
  doYouHavePanCard: 'doYouHavePanCard',
  nameAsPerPanCard: 'nameAsPerPanCard',
  panCardNumber: 'panCardNumber',
  fatherNameAsPerPan: 'fatherNameAsPerPan',
  dobAsPerPan: 'dobAsPerPan',
  gstRegistered: 'gstRegistered',
  gstRegistrationType: 'gstRegistrationType',
  gstInOrUin: 'gstInOrUin',
  gstDetailsProof: 'gstDetailsProof',
  gstFillingFrequency: 'gstFillingFrequency',
  gstAddress: 'gstAddress',
  gstCity: 'gstCity',
  gstState: 'gstState',
  gstCountry: 'gstCountry',
  gstPinCode: 'gstPinCode',
  bankDetailsProof: 'bankDetailsProof',
  panDetailsProof: 'panDetailsProof',
  bankDetailsProofUrl: 'bankDetailsProofUrl',
  panDetailsImageUrl: 'panDetailsImageUrl',
  gstDetailsImageUrl: 'gstDetailsImageUrl',
  nameAsPerGst: 'nameAsPerGst',
  billingDetailsDeclaration: 'billingDetailsDeclaration',
  bankDetailsDeclaration: 'bankDetailsDeclaration',
  verificationAmount: 'verificationAmount',
  billingDetailsName: 'billingDetailsName',
  doYouHaveGst: 'doYouHaveGst',
  doYouHavePan: 'doYouHavePan',
  streetName: 'streetName',
  consentForUpdateBankDetails: 'consentForUpdateBankDetails'
};

export const fieldTypes = {
  text: 'text',
  email: 'email',
  select: 'select',
  submit: 'submit',
  button: 'button',
  password: 'password',
  otp: 'OTP',
  tandc: 'tAndC',
  number: 'number',
  radio: 'radio',
  checkbox: 'checkbox'
};

export const bankDetailsGlobalErrorFieldClassName =
  'bank-details-global-error-field';

export const profileUpdateFormGlobalFieldClassName =
  'profile-details-global-error-field';

export const paymentDetailsFormGlobalFieldClassName =
  'payment-details-global-error-field';

export const publicRegistrationFormGlobalFieldClassName =
  'public-registration-form-global-error-field';
